import { render, staticRenderFns } from "./ControlWidgetShape.vue?vue&type=template&id=be62b630&scoped=true"
import script from "./ControlWidgetShape.vue?vue&type=script&lang=js"
export * from "./ControlWidgetShape.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgetShape.vue?vue&type=style&index=0&id=be62b630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be62b630",
  null
  
)

export default component.exports